import type { ColumnDef } from 'components/SelectableGrid/types';

export const COLUMNS_VARIABLE = '--selectable-grid-row-columns';

export const REPORT_COLUMNS: ColumnDef[] = [
    { header: 'Pilot' },
    { header: 'Drone' },
    { header: 'Start Time' },
    { header: 'Duration' },
    { header: 'Area' },
    { header: 'Type', isResizable: false }
];

export const TEST_ID = 'selectableFlightsGrid';
